import { CreateBranchPayload, CreateTenantPayload, Tenant, TenantBranding, TenantsResponse, UpdateTenantPayload } from "../../types/tenant";
import apiClient from "./config";

export const fetchAllTenants = async (): Promise<TenantsResponse> => {
    const response = await apiClient.get(`/admin/tenants`);
    return response.data;
}

export const fetchTenantById = async (tenantId: string): Promise<Tenant> => {
    const response = await apiClient.get(`/admin/tenants/${tenantId}`);
    return response.data.data;
}

export const createTenant = async (tenantData: CreateTenantPayload): Promise<Tenant> => {
    const response = await apiClient.post(`/admin/tenants`, tenantData);
    return response.data.data;
}

export const createBranchTenant = async (tenantId: string, tenantData: CreateBranchPayload): Promise<Tenant> => {
    const response = await apiClient.post(`/admin/tenants/${tenantId}/branches`, tenantData);
    return response.data.data;
}

export const updateTenant = async (tenantId: string, tenantData: UpdateTenantPayload): Promise<Tenant> => {
    const response = await apiClient.put(`/admin/tenants/${tenantId}`, tenantData);
    return response.data.data;
}

// B3 — reenvía la invitación de una persona de contacto que aún no ha entrado.
// Solo sirve para quien no haya aceptado todavía: si ya tiene cuenta, el backend
// responde 409 y el camino es "¿Olvidaste tu contraseña?" en el login.
export const resendContactPersonInvitation = async (
    tenantId: string,
    email: string
): Promise<{ message: string }> => {
    const response = await apiClient.post(`/admin/tenants/${tenantId}/contact-persons/resend`, { email });
    return response.data;
}

export const deactivateTenant = async (tenantId: string): Promise<void> => {
    return apiClient.delete(`/admin/tenants/${tenantId}`);
}

export const fetchTenantBranding = async (code: string): Promise<TenantBranding> => {
    const response = await apiClient.get(`/public/tenants/${code}/branding`);
    return response.data.data;
}